<script lang="ts">
  export let centers: any;
  export let stats: any;

  import OneCane from "../common/OneCane.svelte";
  import { MakeSortable, SortHeader } from 'svelte-simple-table';
  import Fa from 'svelte-fa';
  import { faSort } from '@fortawesome/free-solid-svg-icons';

  const canes = getCanes(centers);

  function getCanes(centers) {
    const canesById = new Map<number, any>();
    const canes = [];

    for (let center of centers) {
      const cane = center.cane;
      const caneId = cane.caneId;
      if (canesById.get(caneId) === undefined) {
        canesById.set(caneId, {
          cane: cane,
          radius: center.radius,
          qty: 1,
        });
      } else {
        canesById.get(caneId).qty++;
      }
    }

    // console.log(canesById);
    for (const [caneId, caneInfo] of canesById) {

      let score = 0;
      const properties = [];
      const cane = caneInfo.cane;

      if (cane.isClassicSignature) {
        properties.push('classic signature');
        score += 10;
      }
      if (cane.isRareSignature) {
        properties.push('rare signature');
        score += 20;
      }
      if (cane.isUnique) {
        properties.push('unique');
        score += 2;
      }
      if (cane.fromLib) {
        properties.push('from lib');
        score += 5;
      }
      if (cane.isCentral) {
        properties.push('central');
        score += 8;
      }
      const complexity = cane.elts.length;
      if (complexity === stats.simplestCane) {
        properties.push('simple');
      }
      if (complexity === stats.mostComplexCane) {
        properties.push('complex');
        score += 4;
      }

      score += complexity;

      canes.push({
        id: caneId, 
        qty: caneInfo.qty, 
        complexity: complexity, 
        props: properties, 
        caneData: cane,
        score: score,
        size: Math.round(caneInfo.radius * 100),
      });
    }
    
    canes.sort((caneA, caneB) => {
      return caneB.score - caneA.score;     
    });
    
    //console.log(canes);
    return canes;
  };


  const tooltips = {
    'simple': 'a rather simple cane for that paperweight',
    'complex': 'a rather complex cane for that paperweight',
    'classic signature': 'the standard red signature, when the paperweight is signed',
    'rare signature': 'a non standard, rare signature, that might appear instead of or complementary to a standard signature',
    'central': 'the cane which is central to the paperweight',
    'unique': 'the cane is unique within the paperweight',
    'from lib': 'an existing, historical cane, that exists in real world paperweights',
  };

</script>

<span>
  <MakeSortable
    data={canes}
    let:table
    sortIconCss=""
    sortIconAscCss=""
    sortIconDescCss=""
  >
    <table role="grid">
      <thead>
        <tr>
          <th scope="col">Cane</th>
          <SortHeader path="qty">Quantity <Fa icon={faSort} /></SortHeader>
          <SortHeader path="size">Size <Fa icon={faSort} /></SortHeader>
          <SortHeader path="score">Properties <Fa icon={faSort} /></SortHeader>
        </tr>
      </thead>
      <tbody>
        {#each table.pageRows as row}
          <tr>
            <td class="caneIcon">
              {#key row.id}
                <OneCane caneData={row.caneData} size={150} />
              {/key}
            </td>
            <td class="quantity">{row.qty}</td>
            <td class="size">{row.size}</td>
            <td class="properties">
              {#each row.props as property}
                <span class={property.replace(/\s+/g, '_') + ' property'}>
                  <em data-tooltip={tooltips[property]}>{property}</em>
                </span>
              {/each}
              <br/>
              <span class='complexity'><em data-tooltip="number of elements (inner shapes) within the cane">complexity: {row.complexity}</em></span>
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
    <div class="pagination">
      <a name="prev" role="button" class={table.paging.currentPage === 0 ? 'secondary' : 'contrast'} on:click={table.paging.onPrevious}>Previous</a>
      {#each table.paging.buttons as btn (btn)}
        <a name="{'pages' + btn.label}" role="button" class={btn.active ? 'secondary' : 'contrast'} on:click={btn.onClick}>{btn.label}</a>
      {/each} 
      <a name="next" role="button" class={table.paging.currentPage >= table.paging.pageCount-1 ? 'secondary' : 'contrast'} on:click={table.paging.onNext}>Next</a>
    </div>
  </MakeSortable>

</span>

<style>
  .property {
    margin-left: 0.1em;
    margin-right: 0.1em;
    padding: 0.1em;
  }

  .simple {
  }
  .complex {
    color: black;
    background-color: white;
  }

  .classic_signature {
    color: white;
    background-color: red;
  }
  .rare_signature {
    color: white;
    background-color: darkgreen;
  }
  .central {
    color: white;
    background-color: darkblue;
  }
  .unique {
    color: black;
    background-color: cadetblue;
  }
  .from_lib {
    color: white;
    background-color: darkorange;
  }

  a[role="button"] {
    padding-top: 2px;
    padding-bottom: 2px;
  }

  /*
    it does not really fixes size, but at least the size does not change no more when sorting
  */
  .caneIcon {
    width: 150px;
  }
  .quantity, .size {
    width: 160px;
  }
  .properties {
    width: 200px;
  }

</style>
